import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "../data/products";

export default function ProductsPage() {
  useEffect(() => {
    document.title = "Systems — Weldmatix Fusion";
  }, []);

  return (
    <div data-testid="page-products" className="pt-32 md:pt-40 bg-[#FFFFFF]">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-12">
        <div className="eyebrow mb-4">// All Systems</div>
        <h1 className="font-display uppercase tracking-tight text-slate-900 text-5xl md:text-7xl leading-[0.95]">
          Welding & cladding<br /><span className="text-[#0EA5E9]">systems.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-[#475569] leading-relaxed">
          Purpose-engineered OEM systems for weld overlay, pipe cladding and automation —
          built for performance, reliability and global serviceability.
        </p>
      </section>

      <section className="border-t border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
            {PRODUCTS.map((p, i) => (
              <Link
                key={p.slug}
                to={`/products/${p.slug}`}
                data-testid={`products-list-${p.slug}`}
                className="product-card group bg-[#FFFFFF] hover:bg-[#F8FAFC] p-6 md:p-10 grid grid-cols-1 md:grid-cols-2 gap-8 items-center transition-colors"
              >
                <div className="aspect-[4/3] overflow-hidden border border-[#E2E8F0] group-hover:border-[#0EA5E9] transition-colors bg-[#F8FAFC]">
                  <img src={p.image} alt={p.name} className="product-img w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <div className="font-mono-wm text-[10px] tracking-[0.3em] uppercase text-[#0EA5E9] mb-3">
                    SYS / {String(i + 1).padStart(2, "0")}
                  </div>
                  <h2 className="font-display uppercase text-slate-900 text-2xl md:text-3xl tracking-tight leading-tight">{p.name}</h2>
                  <p className="mt-3 text-sm text-[#475569] leading-relaxed">{p.tagline}</p>
                  <div className="mt-6 inline-flex items-center gap-3 text-sm uppercase tracking-[0.2em] text-slate-900 group-hover:text-[#0EA5E9]">
                    Explore System <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
